import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=1fe97188&scoped=true"
import script from "./ScrollBar.vue?vue&type=script&lang=js"
export * from "./ScrollBar.vue?vue&type=script&lang=js"
import style0 from "./ScrollBar.vue?vue&type=style&index=0&id=1fe97188&prod&lang=css"
import style1 from "./ScrollBar.vue?vue&type=style&index=1&id=1fe97188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe97188",
  null
  
)

export default component.exports